export const containsMessage = (errorMessages, ...types) =>
  errorMessages.findIndex((message) => types.indexOf(message.type) !== -1) !== -1;
